import { Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useSelectUser } from '../../redux/hooks/auth';
import { asyncLogout, selectIsAuthenticated } from '../../redux/slices/auth';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { ROOT_PATHS } from '../../Constants';
import { AgFormWrapper } from '../../styles/layouts/pages';
import { FormEvent, MouseEvent } from 'react';
import AgButton from '../../stories/Components/AgButton';

export function UserSelector() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  const {
    selectedUserToken,
    handleSelectUser,
    handleChangeSelectUser,
    messages,
    users
  } = useSelectUser();

  const handleLogout = async (event: MouseEvent) => {
    event.preventDefault();
    await dispatch(asyncLogout());
    navigate(ROOT_PATHS.LOGIN, { replace: true });
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault(); // Prevent the default form submission behavior
    handleSelectUser(); // Call the handleSelectUser function
  };

  return (
    <form onSubmit={handleSubmit}>
      <AgFormWrapper>
        <Typography variant='h6' component='div'>
          AgUnity | Union Manager
        </Typography>

        <FormControl fullWidth>
          <InputLabel id='token-select-label'>
            <FormattedMessage id='SELECT_USER' />
          </InputLabel>
          <Select
            labelId='token-select-label'
            id='token-select'
            value={selectedUserToken}
            label={messages({ id: 'SELECT_USER' })}
            onChange={handleChangeSelectUser}
          >
            {users?.filter(user => user.token && user.isActive).map((user) => (
              <MenuItem key={user.token} value={user.token as string}>
                {user.token}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <AgButton
          disabled={!selectedUserToken}
          type='submit'
          variant='contained'
          label={'SELECT_USER'}
        />

        {!isAuthenticated && <AgButton
          type='button'
          variant='contained'
          onClick={(e: MouseEvent) => handleLogout(e)}
          label={'LOGOUT'}
        />}
      </AgFormWrapper>
    </form>
  );
}

export default UserSelector;
